var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.8 0L0 1.8L8.99999 10.8L18 1.80004L16.2 3.70218e-05L9.00002 7.20002L1.8 0Z","fill":"black"}));
}

Chevron.defaultProps = {"width":"18","height":"11","viewBox":"0 0 18 11","fill":"none"};

module.exports = Chevron;

Chevron.default = Chevron;
